import React, { useCallback } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../context/AdminAuthContext';
import DeskTracker from './DeskTracker';
import { DutyGate } from '../components/OffDutyScreen';

/**
 * Feb 2026 — AdminDeskTracker
 *
 * Thin adapter that mounts the shared mobile-first DeskTracker page
 * with the admin JWT + `/admin/desk/*` base path. Redirects
 * unauthenticated visitors to the admin login. Wrapped in
 * `DutyGate` so off-duty sub-admins get the lock screen just like
 * every other admin-shell page.
 *
 * Wires `onLogout` so the shared page can both (a) auto-sign-out on a
 * 401 from the desk endpoints and (b) drive the manual "Sign Out"
 * header button. Both flows land the user on `/admin/login`.
 */
const AdminDeskTracker = () => {
  const { token, authHeaders, logout } = useAdminAuth();
  const navigate = useNavigate();
  const onLogout = useCallback(() => {
    logout();
    navigate('/admin/login', { replace: true });
  }, [logout, navigate]);

  if (!token) return <Navigate to="/admin/login" replace />;
  return (
    <DutyGate>
      <DeskTracker
        authHeaders={authHeaders}
        basePath="/admin"
        backHref="/admin/my-work"
        onLogout={onLogout}
      />
    </DutyGate>
  );
};

export default AdminDeskTracker;
